// extracted by mini-css-extract-plugin
module.exports = {"container":"MultiSelector_container__1N4h_","column":"MultiSelector_column__1w7VX","item":"MultiSelector_item__3MOuS"};